import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataNotFound from "../../../components/Data Not Found";
import UpdateData from "../../../components/Demo Request Components/UpdateData";
import Pagination from "../../../components/Pagination";
import DeleteModal from "../../../components/Trashed Modal/DeleteModal";
import useLoading from "../../../hooks/useLoading";
import { getDemoRequest } from "../../../lib/api functions/demo_request";
import SkeletonLoader from "../../../shared components/Loader/SkeletonLoader";
import Search from "../../../shared components/Search";
import {
  demoRequestStatus,
  demoRequestStatusMap,
  itemTypesMap,
} from "../../../utils/constants";
import { MainContext } from "../../../utils/private_routes/PrivateRoutes";
import { commonType } from "../lead";
import { ParamType } from "./type";

export const getRequestColor = (status: number): any => {
  switch (status) {
    case 0:
      return "#F5BE5F";
    case 1:
      return "#6BDA9F";
    case 2:
      return "#FF808B";
    default:
      return null;
  }
};

const DemoRequest = () => {
  const { userId, companyId, roles, setting } = useContext(MainContext);
  const [commonData, setCommonData] = useState<commonType>({
    data: undefined,
    modal: false,
    check: "",
  });
  const navigate = useNavigate();
  const [loading, showLoader, hideLoader] = useLoading();
  const [requests, setRequests] = useState<any>([]);
  const [totalResult, setTotalResult] = useState<number>(0);

  const [params, setParams] = useState<ParamType>({
    page: 1,
    per_page: 10,
    company: companyId,
  });

  const fn = {
    deleteData: () => {
      setCommonData({
        data: ["ex1"],
        modal: true,
        check: "delete",
      });
    },
    getDemoRequests: async (params?: ParamType) => {
      showLoader();
      const res = await getDemoRequest(params);
      if (res) {
        setRequests(res.data.demoRequests);
        setTotalResult(res.data.total);
        hideLoader();
      }
    },
    addParam: (value: string) => {
      if (value === "resetFilter") {
        delete params?.type;
        fn.getDemoRequests?.({ ...params, page: 1 });
      } else {
        fn.getDemoRequests?.({ ...params, page: 1, type: value });
      }
    },
  };

  useEffect(() => {
    if (roles?.length !== 0) {
      if (!roles[0]?.demoRequests.complete) {
        params.user = userId;
        fn.getDemoRequests(params);
      } else {
        fn.getDemoRequests(params);
      }
    }
  }, []);

  return (
    <>
      <div className="single_page">
        <div className="data_render_wrapper">
          {/* filters */}
          <div className="filter_wrapper">
            <div className="container-fluid p-0">
              <div className="row align-items-center">
                <div className="col-12 col-md-4">
                  <Search
                    placeholder="Search by client name"
                    state={params}
                    setState={setParams}
                    apiCall={fn.getDemoRequests}
                    paramValue="client.name"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="list_view_wrapper">
            <div className="container-fluid p-0">
              <div className="row align-items-center pb-3">
                <div className="col-12 col-lg-3">
                  <span className="font16x600 textColor3">
                    List of Requests
                  </span>
                </div>
                <div className="col-12 col-lg-9 pt-3 pt-lg-0">
                  <div className="d-flex justify-content-start justify-content-lg-end">
                    <div className="d-flex align-items-center">
                      <span className="font12x500 textColor3">Filter:</span>
                      <div className="ms-2">
                        <select
                          className="form-select font12x500 textColor3 shadow-none dropdown_filter"
                          onChange={(e) => {
                            fn.addParam(e.target.value);
                          }}
                        >
                          <option value="resetFilter">---Type---</option>
                          <option value="1">Product</option>
                          <option value="2">Service</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* table */}
            {requests?.length !== 0 ? (
              <div className="entry_table_wrapper">
                <div className="table_wrapper">
                  <table className="table">
                    <thead className="table_head">
                      <tr className="font12x500 textColor3">
                        <th scope="col">#</th>
                        <th scope="col">Date Created</th>
                        {/* <th scope="col">User Id</th> */}
                        <th scope="col">Sales Person Details</th>
                        <th scope="col">Lead Details</th>
                        <th scope="col">Type</th>
                        <th scope="col">Item</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Note</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requests?.map((request: any, i: number) => {
                        return (
                          <tr key={i} className="font12x400">
                            <th>
                              {(params.page - 1) * params.per_page + (i + 1)}
                            </th>
                            <td>
                              {moment(request?.createdAt).format(
                                setting?.dateFormat
                              )}
                            </td>
                            <td>
                              <span className="textColor2 mb-1">
                                {request?.user?.name}
                              </span>
                              <br />
                              <span>{request?.user?.customUserId}</span>
                            </td>
                            <td
                              className="cursor_pointer"
                              onClick={() =>
                                navigate(
                                  `/lead/view/${request?.lead?._id}/request-demo`,
                                  { state: { _id: request?._id } }
                                )
                              }
                            >
                              <span className="textColor2 mb-1">
                                {request?.lead?.name}
                              </span>
                              <br />
                              <span>{request?.lead?.client?.name}</span>
                            </td>
                            <td>{itemTypesMap.get(request?.type)}</td>
                            <td>{request?.item?.name}</td>
                            <td>{request?.qty}</td>
                            <td style={{ maxWidth: 200 }}>
                              {request?.notes !== "" ? request?.notes : "--"}
                            </td>
                            <td>
                              <UpdateData
                                data={demoRequestStatus}
                                color={getRequestColor(request?.status)}
                                label={demoRequestStatusMap.get(
                                  request?.status
                                )}
                                id={request?._id}
                                apiCall={fn.getDemoRequests}
                                params={params}
                                status={request?.status}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : loading ? (
              <SkeletonLoader />
            ) : (
              <DataNotFound />
            )}
          </div>
        </div>

        {/* pagination */}
        {requests?.length !== 0 && (
          <div className="pagination_wrapper pt-3 px-3">
            <Pagination
              currentPage={params.page}
              onPageChange={(e) => {
                fn.getDemoRequests({ ...params, page: e });
                setParams({
                  ...params,
                  page: e,
                });
              }}
              pageSize={params.per_page}
              totalCount={Math.ceil(totalResult / params.per_page)}
              onChangePerPage={(e) => {
                fn.getDemoRequests({ ...params, per_page: e });
                setParams({
                  ...params,
                  per_page: e,
                });
              }}
            />
          </div>
        )}
      </div>

      {/* delete modal */}
      {commonData?.modal && commonData?.check === "delete" && (
        <DeleteModal
          label="Lead"
          dataIds={commonData?.data}
          setState={setCommonData}
        />
      )}
    </>
  );
};

export default DemoRequest;
